import { _notNil } from '@/littledash';
import { type ReadingTypes } from '@/model/Device.model.ts';

export const stripReading = (reading: string, readingType: ReadingTypes) => {
  let result = '';
  switch (readingType) {
    case 'number': {
      result = stripReadingNumericFormat(reading);
      break;
    }
    case 'trim_channel': {
      result = stripReadingNumericFormat(reading.slice(4));
      break;
    }
    case 'text': {
      result = reading;
      break;
    }
  }
  // remove new lines, tabs and spaces from all readings
  result = result.replaceAll(/[\n\r\s]+/g, '');

  return result;
};

export const stripReadingNumericFormat = (reading: string) => {
  const regex = /[\d.,-]/g;
  const match = reading.match(regex);

  return _notNil(match) ? match.join('') : '';
};
